import type { FunctionComponent } from "react";
import { CarouselItemFormPartial } from "../../../partials/admin/carousel/carousel-item-form.admin.partials";

const EditCarouselItemAdminScreen: FunctionComponent = () => {
  return <CarouselItemFormPartial mode="edit" />;
};

export default EditCarouselItemAdminScreen;
